module.exports = __webpack_public_path__ + "img/logo_verde.f591661e.png";